import { Link } from "react-router-dom";
import { toTitleCase, isPastEvent, formatEventDate } from "./eventUtils";

function EventCard({ event }) {
	const isPast = isPastEvent(event.date);

	return (
		<Link className="eventCard" to={`/events/${event._id}`}>
			<div className="eventCardImageFrame">
				{event.image && (
					<img
						className="eventCardImage"
						src={event.image}
						alt={event.name}
					/>
				)}
				<div className="eventCardScrim" aria-hidden="true"></div>
				<span className={`eventStatusBadge ${isPast ? "past" : "upcoming"}`}>
					{isPast ? "Past event" : "Upcoming"}
				</span>
			</div>

			<div className="eventCardBody">
				<h3 className="eventCardName">{toTitleCase(event.name)}</h3>
				<p className="eventCardMeta">
					{formatEventDate(event.date)}
					{event.venue?.name ? ` · ${event.venue.name}` : ""}
				</p>
			</div>
		</Link>
	);
}

export default EventCard;
